@if(mediaService.deskmode()) {
<div class="flx">
    @switch (menutype()) {
    @case ('2') {
    @for (mm of mymenu?.menuurlaubssuchen; track $index) {
    <clever-menu2-item [menu]="mm"></clever-menu2-item>
    }
    }
    @case ('3') {
    @for (mm of mymenu?.menuurlaubsziele; track $index) {
    <clever-menu2-item [menu]="mm"></clever-menu2-item>
    }
    }
    @case ('4') {
    @for (mm of mymenu?.menuextra; track $index) {
    <clever-menu2-item [menu]="mm"></clever-menu2-item>
    }
    }
    @case ('1') {
    @for (mm of mymenu?.menuoffice; track $index) {
    <clever-menu2-item [menu]="mm"></clever-menu2-item>
    }
    }
    @default {
    @for (mm of mymenu?.allmenus; track $index) {
    <clever-menu2-item [menu]="mm"></clever-menu2-item>
    }
    }
    }
</div>
} @else {
<!-- </für google> -->
<div class="hidden">
    <ng-container *ngTemplateOutlet="allmenus"></ng-container>
</div>
<div class="flxmobile w100">
    <ng-container *ngTemplateOutlet="allmenus"></ng-container>
</div>
}

<ng-template #allmenus>
    @for (mm of mymenu?.menuoffice; track $index) {
    <clever-menu2-item [menu]="mm"></clever-menu2-item>
    }
    @for (mm of mymenu?.menuurlaubssuchen; track $index) {
    <clever-menu2-item [menu]="mm"></clever-menu2-item>
    }
    @for (mm of mymenu?.menuurlaubsziele; track $index) {
    <clever-menu2-item [menu]="mm"></clever-menu2-item>
    }
    @for (mm of mymenu?.menuextra; track $index) {
    <clever-menu2-item [menu]="mm"></clever-menu2-item>
    }
</ng-template>